import React from 'react';
import Icon from '../../ui/icons/Icon';
import iconsList from '../../ui/icons/iconsList';
import classes from './ContentPromotionPopup.module.css';

const PromotionHeader = ({ title, onClose }) => (
    <div className={classes.Header}>
        <Icon name={iconsList.x} size="31px" color="black" className={classes.CloseButton} onClick={onClose} />
        <p className={classes.Title}>{title}</p>
    </div>
);

export default PromotionHeader;
